import React from 'react'
import PropTypes from 'prop-types'
import { observer } from 'mobx-react'
import { observable, toJS } from 'mobx'
import useValue from '../hooks/use-value'
import ModelContext from '../contexts/ModelContext'

function ValueToModel (props) {
  const modelRef = React.useRef(observable.map())
  const model = modelRef.current

  const value = useValue(props.name, props.defaultValue)

  React.useEffect(() => {
    let newValue = value

    if (!newValue) {
      newValue = {}
    }

    model.replace(toJS(newValue))
  }, [value])

  return (
    <ModelContext.Provider value={model}>
      {props.children}
    </ModelContext.Provider>
  )
}

ValueToModel.defaultProps = {
  defaultValue: null
}

ValueToModel.propTypes = {
  name: PropTypes.string.isRequired,
  defaultValue: PropTypes.any
}

export default observer(ValueToModel)
